import { useState } from "react";
import axiosInstance from "../Help/AxiosLogicInstance";

export default function useAuth() {
  const [loading, setLoading] = useState(false);

  const login = async (email, password) => {
    setLoading(true);
    try {
      const res = await axiosInstance.post("/api/Student/StudentLogin", {
        Email: email,
        Password: password,
      });
      if (res.data?.Result?.Token) {
        localStorage.setItem("token", res.data.Result.Token);
        localStorage.setItem("StudentId", res.data.Result.StudentId);
        setLoading(false);
        return { success: true };
      } else {
        setLoading(false);
        return { success: false, message: "Invalid response from server" };
      }
    } catch {
      setLoading(false);
      return { success: false, message: "Invalid email or password" };
    }
  };

  return { login, loading };
}